import { render, staticRenderFns } from "./diffcost.vue?vue&type=template&id=0cc5292f&scoped=true&"
import script from "./diffcost.vue?vue&type=script&lang=js&"
export * from "./diffcost.vue?vue&type=script&lang=js&"
import style0 from "./diffcost.vue?vue&type=style&index=0&id=0cc5292f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5292f",
  null
  
)

export default component.exports